<template>
  <path pid="0" d="M14.71 7.29a1 1 0 10-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 001.42 1.42l5-5a1 1 0 000-1.42z"/><path pid="1" d="M6.29 18.71a1 1 0 001.42 0l5-5a1 1 0 000-1.42l-5-5a1 1 0 10-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 000 1.42z"/>
</template>
